import {
    View,
    Flex,
    Text as SpectrumText,
    Button,
    DialogTrigger,
    Dialog,
    Content,
    Heading,
} from "@adobe/react-spectrum"
import { SlackIcon, EmailIcon } from "../../utilities/components/Icons"

const PreviewTemplate = ({ template, isIndividualMode, onClose, onEdit }) => {
    // console.log("template from line 92 PreviewTemplate.jsx", template)
    // const string = '"Call Abandoned in {QUEUE} queue, Customer number - {CUSTOMER_INFO}\\n\\nhii: {QUEUE}\\n\\nhello: {BU}\\n\\nCall Abandoned in {QUEUE} queue, Customer number - {CUSTOMER_INFO}"'
    const emailContent = template?.emailBody || "";
    const emailLines = emailContent.split('\n');
    const emailSubject = template?.emailSubject || "";
    const emailOpeningStatement = emailLines[0] || "";
    // console.log("emailOpeningStatement from line 100 PreviewTemplate.jsx", emailOpeningStatement)
    const emailClosingStatement = emailLines[emailLines.length - 1] || "";
    // console.log("emailClosingStatement from line 102 PreviewTemplate.jsx", emailClosingStatement)
    const emailAttributes = emailLines.slice(1, -1).filter(line => line.trim() !== "");
    // console.log("emailAttributes from line 104 PreviewTemplate.jsx", emailAttributes)

    const slackContent = isIndividualMode ? (template?.slackMessage || "") : emailContent;
    const slackLines = slackContent.split('\n');
    const slackOpeningStatement = slackLines[0] || "";
    const slackClosingStatement = slackLines[slackLines.length - 1] || "";
    const slackAttributes = slackLines.slice(1, -1).filter(line => line.trim() !== "");

    return (
        <DialogTrigger isOpen={true}>
            <div></div>
            <Dialog width="80vw">
                <Heading>Custom Template Preview</Heading>
                <Content>
                    <Flex direction="row" gap="size-300">
                        <View width="45%">
                            <View
                                UNSAFE_style={{
                                    border: "1px solid #E1E1E1",
                                    borderRadius: "8px",
                                    backgroundColor: "#F5F5F5",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                }}
                            >
                                <header>
                                    <Flex
                                        alignItems="center"
                                        gap="size-100"
                                        UNSAFE_style={{
                                            padding: "12px 20px",
                                            borderBottom: "1px solid #E1E1E1",
                                        }}
                                    >
                                        <EmailIcon />
                                        <h4 style={{ margin: 0, fontWeight: 600 }}>
                                            Email Template
                                        </h4>
                                    </Flex>
                                </header>
                                <View UNSAFE_style={{ padding: "16px 20px" }}>
                                    <View marginBottom="size-200">
                                        <SpectrumText 
                                            UNSAFE_style={{ 
                                                fontWeight: 600,
                                                fontSize: "14px", 
                                                color: "#464646" 
                                            }}
                                        >
                                            Subject:
                                        </SpectrumText>
                                        <SpectrumText UNSAFE_style={{ fontSize: "14px" }}>
                                            {emailSubject || "-"}
                                        </SpectrumText>
                                    </View>
                                    <View marginBottom="size-200">
                                        <SpectrumText UNSAFE_style={{ fontSize: "14px", lineHeight: "1.5" }}>
                                            {emailOpeningStatement}
                                        </SpectrumText>
                                    </View>

                                    {emailAttributes.length > 0 && (
                                        <View marginY="size-200">
                                           
                                            {emailAttributes.map((attr, i) => (
                                                <View
                                                    key={i}
                                                    marginY="size-75"
                                                >
                                                    <SpectrumText UNSAFE_style={{ fontSize: "14px" }}>
                                                        {attr}
                                                    </SpectrumText>
                                                </View>
                                            ))}
                                        </View>
                                    )}

                                    <View marginTop="size-200">
                                        <SpectrumText UNSAFE_style={{ fontSize: "14px", lineHeight: "1.5" }}>
                                            {emailClosingStatement}
                                        </SpectrumText>
                                    </View>
                                </View>
                            </View>
                        </View>
                                        
                        <View width="45%">
                            <View
                                UNSAFE_style={{
                                    border: "1px solid #E1E1E1",
                                    borderRadius: "8px",
                                    backgroundColor: "#F5F5F5",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                }}
                            >
                                <header>
                                    <Flex
                                        alignItems="center"
                                        gap="size-100"
                                        UNSAFE_style={{
                                            padding: "12px 20px",
                                            borderBottom: "1px solid #E1E1E1",
                                        }}
                                    >
                                        <SlackIcon />
                                        <h4 style={{ margin: 0, fontWeight: 600 }}>
                                            Slack Template
                                        </h4>
                                    </Flex>
                                </header>
                                <View UNSAFE_style={{ padding: "16px 20px" }}>
                                    <View marginBottom="size-200">
                                        <SpectrumText UNSAFE_style={{ fontSize: "14px", lineHeight: "1.5" }}>
                                            {slackOpeningStatement}
                                        </SpectrumText>
                                    </View>

                                    {slackAttributes.length > 0 && (
                                        <View marginY="size-200">
                                           
                                            {slackAttributes.map((attr, i) => (
                                                <View
                                                    key={i}
                                                    marginY="size-75"
                                                >
                                                    <SpectrumText UNSAFE_style={{ fontSize: "14px" }}>
                                                        {attr}
                                                    </SpectrumText>
                                                </View>
                                            ))}
                                        </View>
                                    )}

                                    <View marginTop="size-200">
                                        <SpectrumText UNSAFE_style={{ fontSize: "14px", lineHeight: "1.5" }}>
                                            {slackClosingStatement}
                                        </SpectrumText>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </Flex>
                    <Flex
                        justifyContent="end"
                        gap="size-200"
                        marginTop="size-300"
                    >
                        <Button
                            variant="secondary"
                            onPress={onClose}
                        >
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onPress={onEdit}
                        >
                            Edit
                        </Button>
                    </Flex>
                </Content>
            </Dialog>
        </DialogTrigger>
    )
}

export default PreviewTemplate 